/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Cta_SecondaryInputs */

const en_services_cta_secondary = /** @type {(inputs: Services_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore use cases`)
};

const lv_services_cta_secondary = /** @type {(inputs: Services_Cta_SecondaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apskatīt piemērus`)
};

/**
* | output |
* | --- |
* | "Explore use cases" |
*
* @param {Services_Cta_SecondaryInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_cta_secondary = /** @type {((inputs?: Services_Cta_SecondaryInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Cta_SecondaryInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_cta_secondary(inputs)
	return en_services_cta_secondary(inputs)
});